import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
// import AddTKCSOrderDispatch from "./AddTKCSOrderDispatch";
// import UpdateTKCSOrderDispatch from "./UpdateTKCSOrderDispatch";
import { sweetAlert } from "../../Common/Utills/Utills";
import AddTripDispatchDetails from "./AddTripDispatchDetails";
import UpdateTripDispatchDetails from "./UpdateTripDispatchDetails";
import { minDate } from "../../Constants/Constants";

const TripDispatchDetails = () => {
  const [tripDispatchDetails, setTripDispatchDetails] = useState([]);
  const params = useParams();
  const formRef = useRef(null);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowId, setRowId] = useState("");
  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [showSearch, setShowSearch] = useState(false);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const [filterCriteria, setfilterCriteria] = useState({
    order_number_id: "",
  });
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(-1);
  };

  const [tripId, setTripId] = useState(params.id);
  const getSingleData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/trips/single-trip/${user_id}?trip_id=${tripId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTripDispatchDetails(result.data);
    } else {
      setTripDispatchDetails([]);
    }
  };

  useEffect(() => {
    if (tripId) {
      getSingleData();
    }
  }, [params]);

  useEffect(() => {
    setfilterCriteria({
      order_number_id: tripDispatchDetails?.id,
    });
  }, [tripDispatchDetails]);

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    // gridRef.current.api.showLoadingOverlay();
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    // gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const getData = async () => {
    let BASE_URL =
      SERVER_URL +
      `/api/trips-dispatch/single-trip-all-dispatch/${user_id}?trip_id=${tripId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setRowData(result.data);
    } else {
      setRowData([]);
    }
  };

  useEffect(() => {
    if (tripId) {
      getData();
    }
  }, [tripId]);

  const deleteTripDispatchData = async (order_id, type) => {
    const message = "Do you want to delete this trip dispatch details!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL = SERVER_URL + `/api/trips-dispatch/trips-dispatch/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: order_id,
        type: type
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
    }
  };

  const addDataToModal = (id) => {
    setRowId(id);
  };
  const dispatchTypes = {
    govt: "Government",
    private: "Private",
    tkcs: "TKCS",
    material: "Material",
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            View Trip Dispatch Details &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleNavigate}
              >
                <i
                  className="mdi mdi-arrow-left"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
                Back{" "}
              </button>
            </span>
          </div>
          <div className="form-container">
            <form className="form-sample">
              {/* <p className="card-description">Personal info</p> */}
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="company_name">Starting Point</label>
                    <input
                      type="text"
                      className="form-control"
                      name="company_name"
                      id="company_name"
                      value={
                        tripDispatchDetails?.companyDetails?.company_name +
                        ", " +
                        tripDispatchDetails?.companyDetails?.location
                      }
                      readOnly
                      placeholder="DI Number"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="start_date">Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="start_date"
                      id="start_date"
                      value={tripDispatchDetails?.start_date}
                      readOnly
                      min={minDate}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="vehicle_number">Vehicle Number</label>
                    <input
                      type="text"
                      className="form-control"
                      name="vehicle_number"
                      id="vehicle_number"
                      placeholder="Product Name"
                      value={
                        tripDispatchDetails?.vehicleDetails?.vehicle_number
                      }
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="total_distance">Total Distance</label>
                    <input
                      type="number"
                      className="form-control"
                      name="total_distance"
                      id="total_distance"
                      placeholder="Total Distance"
                      value={tripDispatchDetails?.total_distance}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="card mt-2">
        <div className="private-table-container">
          <div className="card-body">
            <div className="table_btn">
              <div className="mb-3">
                <button
                  data-toggle="modal"
                  data-target="#tripDetailsDispatchAdd"
                  className="btn btn-outline-primary"
                >
                  <span className="mr-1">
                    <i className="mdi mdi-briefcase-upload" />
                  </span>
                  Add Trip Dispatch Details
                </button>
              </div>
              <div
                style={{
                  marginBottom: "20px",
                }}
              ></div>
            </div>
            <div
              className="table-responsive table-bordered govt-table"
              style={{ border: "0.05px solid lightGray", width: "auto" }}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>Dispatch Type (Party)</th>
                    <th>Order/Di Number</th>
                    <th>RCA/PO Number</th>
                    <th>Party Name</th>
                    <th>Product/Material Name</th>
                    <th>Unload Destination</th>
                    <th>Unload Quantity</th>
                    <th>Vehicle Reading</th>
                    <th>Remarks</th>
                    <th style={{ textAlign: "center" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rowData && rowData.length > 0 ? (
                    rowData &&
                    rowData?.length > 0 &&
                    rowData?.map((detail, detailIndex) => (
                      <tr key={detailIndex}>
                        <td>{detailIndex + 1}</td>
                        <td>{dispatchTypes[detail?.dispatch_type]}</td>
                        <td>
                          {detail?.dispatchDetails?.govtOrderNumber
                            ?.order_number ||
                            detail?.dispatchDetails?.privateDiNumber
                              ?.di_number ||
                            // detail?.dispatchDetails?.privateLocalOrders
                            //   ?.party_name ||
                            "-"}
                        </td>
                        <td>
                          {detail?.dispatchDetails?.govtOrderNumber
                            ?.govtOrderDetails?.govtOrders?.rca_number ||
                            detail?.dispatchDetails?.privateDiNumber
                              ?.privateOrderDetails?.privateOrders?.po_number ||
                            "-"}
                        </td>
                        <td>
                          {detail?.dispatchDetails?.privateDiNumber
                            ?.privateOrderDetails?.privateOrders?.party_name ||
                            detail?.dispatchDetails?.privateLocalOrders
                              ?.party_name ||
                            detail?.dispatchDetails?.party_name ||
                            "-"}
                        </td>
                        <td>
                          {detail?.dispatchDetails?.rawMaterialName
                            ?.material_name ||
                            detail?.dispatchDetails?.dispatch_details[0]?.size}
                        </td>
                        <td>{detail?.unload_destination}</td>
                        <td>{detail?.unload_qty}</td>
                        <td>{detail?.vehicle_reading}</td>
                        <td>{detail?.remarks ? detail?.remarks : "-"}</td>
                        <td
                          style={{
                            verticalAlign: "middle",
                            textAlign: "center",
                          }}
                        >
                          <span>
                            <button
                              className="btn btn-outline-secondary btn-sm ml-2"
                              onClick={() => addDataToModal(detail.id)}
                              data-toggle="modal"
                              data-target="#update"
                            >
                              <i className="mdi mdi-note-edit-outline" />
                            </button>{" "}
                            <button
                              className="btn btn-outline-danger btn-sm ml-2"
                              onClick={() => deleteTripDispatchData(detail.id, detail.dispatch_type)}
                            >
                              <i className="mdi mdi-delete" />
                            </button>
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="18">
                        <div className="loading-container">
                          <p>No row to show</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <AddTripDispatchDetails
              formRef={formRef}
              getData={getData}
              tripId={tripId}
              setOrderId={setTripId}
            />
            <UpdateTripDispatchDetails
              rowId={rowId}
              setRowId={setRowId}
              getData={getData}
              tripId={tripId}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TripDispatchDetails;
